export function getRepresentativeDisplayName() {
  try {
    const vision = JSON.parse(localStorage.getItem("userDetailVision"));
    const detail = JSON.parse(localStorage.getItem("userDetail"));
    return vision?.Nome ?? detail?.Nome ?? "";
  } catch {
    return "";
  }
}

export function formatBRL(value) {
  if (value === "" || value === undefined || value === null) return "—";
  const n = typeof value === "number" ? value : Number(value);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function resolvePrecoKarstenNumerico(precoState) {
  if (precoState !== "" && precoState !== undefined && precoState !== null) {
    const n = Number(precoState);
    if (!Number.isNaN(n) && n > 0) return n;
  }
  return null;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
